<script>
    import { onMount } from "svelte";
    import { lang } from "../scripts/stores";
    import { fade, fly } from "svelte/transition";
    import Overlay from "./Overlay.svelte";

    export let details = "";
    export let title = "Muistiinpano";
    export let text = "Voit kirjoittaa arvioitavaan kohtaan liittyviä muistiinpanoja tähän";
    export let buttonText = "Tallenna";
    export let open = false;

    let orginalDetails;

    function acceptButtonAction() {
        console.log(details);
        orginalDetails = details;

        setTimeout(() => {
            open = false;            
        }, 400);
    }

    function closeModal() {
        details = orginalDetails;
        open = false;
    }

    onMount(() => {
        orginalDetails = details;
    });
</script>

<style>
    .svelte-modal {
        background: #fff;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 480px;
        max-width: 85%;
        height: fit-content;
        max-height: 80%;
        padding: .8rem;
        background: #fff;
        text-align: center;
        font-size: 18px;
        overflow-y: auto;
        z-index: 300;
        border: 1px solid gray;
        border-radius: 20px;
    }
    .svelte-modal h2 {
        margin-bottom: 2rem;
    }
    .svelte-modal .action {
        display: flex;
        width: 100%;
        justify-content: space-evenly;
        justify-items: center;
        padding: 1rem .5rem;
        margin-top: 1rem;
    }
    .close-btn {
        position: absolute;
        top: 0.5rem;
        right: 1rem;
        font-weight: 600;
        border: none;
        background: none;
    }
    select {
        margin-top: 1.5rem;
    }
</style>

{#if open}
    <div class="svelte-modal" in:fly={{ duration: 200, y: 200 }} out:fade={{ duration: 200 }}>
        
        <h2> 
            { $lang === "fi" ? "Mustiinpanot" : "Notes" }
        </h2>
        <p>({ title })</p> 

        <div class="form-control">
            <label class="label" for="details">
                <span class="label-text">{ $lang === "fi" ? "Muistiinpanot" : "Notes"}</span>
            </label> 
            <textarea id="details" class="textarea textarea-bordered" bind:value={ details }></textarea>
        </div>

        <div class="action">
            <button class="btn" on:click={ closeModal }>
                { $lang === "fi" ? "Peruuta" : "Cancel"}
            </button>
            <button  class="btn btn-primary" on:click={ acceptButtonAction }> 
                { $lang === "fi" ? "Tallenna" : "Save"}
            </button> 
        </div>
    </div>

    <Overlay show={ open } on:click={ closeModal } />
{/if}
